import React, {useContext, useEffect, useState} from 'react';

import THEME from "../../assets/styles/config";
import ICONS from "../../assets/icons"

import JobListContext from "../../app/context/jobListContext";
import assetListContext from "../../app/context/assetListContext";
import useWindowDimensions from "../../hooks/useWindowDimensions";

import {
  SearchTabCtn,
  CloseBtn,
  SearchCriteriaCloseText,
  OverflowCtn,
  TabletOpenBtn,
  ApplyBtn,
  CancelBtn,
  ButtonCtn
} from "./index.style";

interface searchTab {
  submitFilter: (e) => {},
  showTab: boolean,
}

const SearchTab:React.FC<searchTab> = (props) => {
  const { openJobDetails, updateOpenJobDetails } = useContext(JobListContext);
  const { openAssetDetails,updateOpenAssetDetails } = useContext(assetListContext);
  const { submitFilter, asset } = props;

  const { width } = useWindowDimensions();
  const [showSearchTab, setShowSearchTab] = useState(!(width < THEME.layout.desktopLarge.breakpoint));

  const openSearchTab = () => {
    if (!showSearchTab) {
      setShowSearchTab(true);
      if(asset) {
        updateOpenAssetDetails(false);
      } else {
        updateOpenJobDetails(false);
      }
    }
  };

  const toggleSearchTab = () => {
    if (showSearchTab) {
      if(asset) {
        updateOpenAssetDetails(true);
      } else {
        updateOpenJobDetails(true);
      }
    }
    setShowSearchTab(!showSearchTab);
  };

  useEffect(() => {
    if(asset) {
      if(openAssetDetails) {
        setShowSearchTab(false);
      }
    } else {
      if (openJobDetails) {
        setShowSearchTab(false);
      }
    }
  }, [openJobDetails, openAssetDetails]);

  useEffect(() => {
    setShowSearchTab(props.showTab);
  },[props.showTab]);

  const submit = (e) => {
    if (width < THEME.layout.desktop.breakpoint) {
      setShowSearchTab(false);
      if(asset) {
        updateOpenAssetDetails(true);
      } else {
        updateOpenJobDetails(true);
      }
    }
    submitFilter(e)
  };

  return (
    <React.Fragment>
      <SearchTabCtn show={showSearchTab} onClick={openSearchTab}>
        <CloseBtn show={showSearchTab} onClick={toggleSearchTab}>
          <ICONS.chevronRight />
        </CloseBtn>
        <SearchCriteriaCloseText>Search Criteria</SearchCriteriaCloseText>
        <OverflowCtn show={showSearchTab}>
          {props.children}
          <ButtonCtn>
            <ApplyBtn type="submit" onClick={submit} value="APPLY" />
            <CancelBtn type="button" onClick={toggleSearchTab}>
              CANCEL
            </CancelBtn>
          </ButtonCtn>
        </OverflowCtn>
      </SearchTabCtn>
      <TabletOpenBtn>
        <button type="button" onClick={toggleSearchTab}>
          SEARCH CRITERIA
        </button>
      </TabletOpenBtn>
    </React.Fragment>
  )
};

export default SearchTab;